import React from "react";
import { connect } from "react-redux";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";
import AppInfoTable from "components/app/AppInfoTable";
import { getErrorCode } from "lib/error-details";

import errorImage from "components/assets/images/error.svg";
import moment from "moment";
import { reload } from "state/app/actions";

import "./ErrorDetailsModal.css";

const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

/**
 * Show the user some key information after an error has occurred.
 * More helpful for our diagnostic than theirs.
 */
class ErrorDetailsModal extends React.Component {

  /**
   * Some details will be hidden based on this result.
   * In dev we show everything, prod we show less.
   */
  shouldObfuscate() {
    return process.env.NODE_ENV !== "development";
  }

  getAction(error) {
    if(getErrorCode(error) === "UNKNOWN_DEVICE - APP_003") {
      return "Device is no longer registered, please register again. If the issue persists then report this to our support team.";
    }
    return "Please close and reopen the app. If the issue persists then report this to our support team.";
  }

  getMessage(error) {
    const errorCode = getErrorCode(error);

    if(errorCode === "UNKNOWN_DEVICE - APP_003") {
      return "We are unable to recognise your device.";
    }

    if(errorCode === "API_ERROR - APP_001" || errorCode === "API_DATA_ERROR - APP_002") {
      return "We are unable to process the data we received for your device.";
    }
    return "We are unable to process your request.";
  }

  render() {
    const { isOpen, error } = this.props;
    return (
      <ModalDialog isOpen={isOpen}>
        <div className="error-details-modal">
          <div>
            <img className="error-details-modal__image" src={errorImage} alt="Error" />
            <h1 className="error-details-modal__title">Error</h1>
          </div>
          <div className="error-details-modal__description">
            We're sorry, but the system has encountered a serious error and cannot continue.
          </div>
          <hr className="error-details-modal__separator"/>
          <div className="error-details-modal__section">
            <AppInfoTable cssBlockName="error-app-info-table" />
          </div>
          <div className="error-details-modal__section">
            <div className="error-details-modal__label">Code</div>
            <div className="error-details-modal__detail">{getErrorCode(error)}</div>
          </div>
          <div className="error-details-modal__section">
              <div className="error-details-modal__label">Message</div>
              <div className="error-details-modal__detail">{this.getMessage(error)}</div>
          </div>
          <div className="error-details-modal__section">
              <div className="error-details-modal__label">Date / Time</div>
              <div className="error-details-modal__detail">{moment(new Date()).format(DATE_TIME_FORMAT)}</div>
          </div>
          <div className="error-details-modal__section">
            <div className="error-details-modal__label">Action</div>
            <div className="error-details-modal__detail">{this.getAction(error)}</div>
          </div>

          {
            this.shouldObfuscate() ?
            null :
            <div className="error-details-modal__section">
              <div className="error-details-modal__label">Stack Trace</div>
              <div className="error-details-modal__detail">{error.stack}</div>
            </div>
          }
        </div>
        <div className="error-details-modal__button-container">
          <Button className="error-details-modal__refresh-button" onClick={this.props.reload}>Reload Application</Button>
        </div>
      </ModalDialog>
    )
  }

}

export default connect(
  undefined,
  { reload }
)(ErrorDetailsModal);



// WEBPACK FOOTER //
// ./src/components/app/error/ErrorDetailsModal.js